<nz-layout nzTheme="dark">
    <nz-sider>
        <ul nz-menu>
            <li nz-menu-group nzTitle="Layout">
                <ul>
                    <li nz-menu-item (click)="addContainer();">
                        <i nz-icon nzType="border" nzTheme="outline"></i>
                        <span>Container</span>
                    </li>
                    <li nz-menu-item (nzClick)="addContainer();">
                        <i nz-icon nzType="block" nzTheme="outline"></i>
                        <span>Block</span>
                    </li>
                </ul>
            </li>
        </ul>
    </nz-sider>
    <nz-layout>
        <nz-header>Header</nz-header>
        <nz-content>
            <div cdkDropList (cdkDropListDropped)="containersSorting($event)">
                <div nz-row cdkDrag cdkDropList [cdkDragDisabled]="disableDrag" class="container"
                    (cdkDropListDropped)="columnsSorting(container, $event)" *ngFor="let container of containers">
                    <div nz-col nz-resizable cdkDrag [cdkDragDisabled]="disableDrag" [nzMinColumn]="3"
                        [nzMaxColumn]="24" [nzGridColumnCount]="24" [nzSpan]="column.CssClass" class="column gutter-row"
                        (nzResizeStart)="resizeStart($event);" (nzResizeEnd)="resizeStop($event)"
                        (nzResize)="onColumnResize(column, $event)" *ngFor="let column of container.Columns">
                        <nz-resize-handles [nzDirections]="['right', 'left']"></nz-resize-handles>
                        Id: {{column.Id}}
                        {{column.CssClass}}
                    </div>
                    <button nz-button nzBlock nzType="dashed" (click)="addColumn(container);">Add new column</button>
                </div>
            </div>
            <div nz-row class="add-new-container">
                <button nz-button nzBlock nzType="dashed" (click)="addContainer();">Add new container</button>
            </div>
        </nz-content>
        <nz-footer>Footer</nz-footer>
    </nz-layout>
</nz-layout>